module.exports = __webpack_public_path__ + "img/bx-teaching-time-active.0d3964f8.svg";